import React, { useEffect, useState } from "react";
import './alllatestupdate.css';

const BASE_API_URL = "https://cms.gammadda.lk/wp-json/wp/v2/posts?categories=8&per_page=3&_embed";

const AllLatestUpdate = () => {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchProjects = async (pageNumber) => {
    try {
      setLoading(true);
      const response = await fetch(`${BASE_API_URL}&page=${pageNumber}`);
      if (!response.ok) {
        if (response.status === 400 || response.status === 404) {
          setHasMore(false);
        }
        return;
      }

      const data = await response.json();
      if (data.length > 0) {
        // Append only new posts
        setProjects((prevProjects) => [
          ...prevProjects,
          ...data.filter((newPost) => !prevProjects.some((oldPost) => oldPost.id === newPost.id)),
        ]);
        setPage(pageNumber);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects(1); // Start with page 1
  }, []);

  const loadMore = () => {
    if (!loading && hasMore) {
      const nextPage = page + 1;
      fetchProjects(nextPage);
    }
  };

  const getImageUrl = (post) => {
    if (post._embedded && post._embedded["wp:featuredmedia"] && post._embedded["wp:featuredmedia"][0]) {
      return post._embedded["wp:featuredmedia"][0].source_url;
    }
    return "default-image.jpg";
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <div className="news-container">
      {projects.map((post) => {
        const imageUrl = getImageUrl(post);
        const date = formatDate(post.date);
        const title = post.title.rendered;
        const isVideo = imageUrl.includes("youtube") || imageUrl.includes("embed");

        return (
          <div key={post.id} className="news-card">
            {isVideo ? (
              <div className="news-video">
                <iframe
                  width="100%"
                  height="250"
                  src={imageUrl}
                  title="News video"
                  frameBorder="0"
                  allowFullScreen
                />
              </div>
            ) : (
              <div className="news-image">
                <img 
                 style={{width:"100%",height: "inherit",objectFit:"cover"}}
                  src={imageUrl}
                  alt="News"
                />
              </div>

            )}
            <div className="news-content">
              <div className="news-date">{date}</div>
              <div
                className="news-title"
                dangerouslySetInnerHTML={{ __html: title }}
              />
              <a
                className="news-link"
                href={`/news/${post.slug}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                Learn more
              </a>
            </div>
          </div>
        );
      })}

      {hasMore && (
        <div className="text-center my-4">
          <button
            className="btn load-more-button"
            onClick={loadMore}
            disabled={loading}
          >
            {loading ? "Loading..." : "Load More"}
          </button>
        </div>
      )}
    </div>
  );
};

export default AllLatestUpdate;
